import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const profilesRoute: RouteConfig = {
  path: '',
  name: 'profiles',
  component: () => import(/* webpackChunkName: "ProfileList" */ '@/views/mainRoute/profile/List.vue'),
  meta: { authorized: true },

  beforeEnter: (to: any, from: any, next: any) => {
    store
      .dispatch('profile/list')
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.PROFILE_CANNOT_LIST }));
  }
};
